import React from "react";
import { TRUST_BAR } from "@/data/content";

export const TrustBar = ({ quote }) => (
  <div data-testid="trust-bar" className="border-t border-forest/10 bg-creamdark/50">
    <div className="container-nb py-7 flex flex-wrap items-center justify-center gap-x-9 gap-y-4">
      {TRUST_BAR.map(({ icon: Icon, label }) => (
        <div key={label} className="flex items-center gap-2 text-forest/75">
          <Icon size={17} strokeWidth={1.6} className="text-gold" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.1em]">{label}</span>
        </div>
      ))}
      {quote && <p className="font-serif italic text-forest text-sm sm:text-base w-full lg:w-auto text-center">{quote}</p>}
    </div>
  </div>
);
